var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-xs",class:_vm.subscriberIsExtendable ? 'btn-success' : 'btn-warning',attrs:{"disabled":!_vm.subscriberIsExtendable,"type":"button"},on:{"click":_vm.confirmExtendTestDrive}},[_vm._v("\n  Extend\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }